import { Helmet } from "react-helmet-async";
import { useSettings } from "@/context/SettingsContext";

export default function SEO({ title, description, image, url, type = "website", schema, schemas }) {
  const { settings } = useSettings();
  const siteName = settings.site_name || "HyderabadTourism.in";
  const finalTitle = title
    ? `${title} | ${siteName}`
    : settings.seo_meta_title || `${siteName} — Tours, Hotels, Tickets, Cabs, Adventure`;
  const finalDesc = description || settings.seo_meta_description ||
    "Book Hyderabad tours, entry tickets, hotels, cabs and adventures. Since 2005.";
  const finalImage = image || settings.seo_og_image;
  const finalUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const keywords = settings.seo_meta_keywords || "";

  // Accept either legacy `schema` (single) or `schemas` (array). Filter out falsy entries.
  const schemaBlocks = (schemas && schemas.length ? schemas : (schema ? [schema] : []))
    .filter(Boolean);

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={finalUrl} />
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      {finalImage && <meta property="og:image" content={finalImage} />}
      <meta property="og:url" content={finalUrl} />
      <meta property="og:site_name" content={siteName} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      {finalImage && <meta name="twitter:image" content={finalImage} />}
      {/* AI-crawler friendly */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      {schemaBlocks.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
